/* eslint-disable react/display-name */

import DataTable from '../../../components/table/tableOption'
import React from 'react'
import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { cleanStateCase } from '../../../store/actions'
import { connect } from 'react-redux'

const TableImplicated = ({
  data,
  form,
  fechaSiniestro,
  idCaso,
  idOrgano,
  idImplicado,
  onCleanState
}) => {
  const history = useNavigate()

  const handleClickTable = (row) => {
    history('/editar-implicado-tercero', {
      state: {
        row,
        idCaso: idCaso,
        idOrgCaso: idOrgano,
        idImplicado,
        fechaSiniestro: fechaSiniestro,
        form
      }
    })
    onCleanState()
  }

  const columns = [
    {
      dataField: 'NombreImplicado',
      text: form?.formLabel['gestcasos-grillaimpl-nomrazsoc'],
      sort: true,
      headerAlign: 'center',
      align: 'center'
    },
    {
      dataField: 'TipoVehiculo',
      text: form?.formLabel['gestcasos-grillaimpl-tipovh'],
      sort: true,
      headerAlign: 'center',
      align: 'center'
    },
    {
      dataField: 'PlacaPatente',
      text: form?.formLabel['gestcasos-grillaimpl-patente'],
      sort: true,
      headerAlign: 'center',
      align: 'center'
    },
    {
      dataField: 'TipoGestion',
      text: form?.formLabel['gestcasos-grillaimpl-tipogestion'],
      sort: true,
      headerAlign: 'center',
      align: 'center'
    },
    {
      dataField: 'EstadoCaso',
      text: form?.formLabel['gestcasos-grillaimpl-estado'],
      sort: true,
      headerAlign: 'center',
      align: 'center'
    },
    {
      dataField: 'FechaEstadoFormat',
      text: form?.formLabel['gestcasos-grillaimpl-fecestado'],
      sort: true,
      headerAlign: 'center',
      align: 'center'
    },
    {
      dataField: 'SeguroImplicado',
      text: form?.formLabel['gestcasos-grillaimpl-seguro'],
      sort: true,
      headerAlign: 'center',
      align: 'center'
    },
    {
      dataField: 'CiaImplicado',
      text: form?.formLabel['gestcasos-grillaimpl-cia'],
      sort: true,
      headerAlign: 'center',
      align: 'center'
    },
    {
      dataField: '',
      text: 'Acción',
      headerAlign: 'center',
      align: 'center',
      formatter: (cellContent, row) => {
        return (
          <Button
            type='button'
            variant='outline-secondary me-md-2'
            size='sm'
            onClick={() => handleClickTable(row)}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='16'
              height='16'
              fill='currentColor'
              className='bi bi-gear-fill'
              viewBox='0 0 16 16'
            >
              <path d='M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z' />
            </svg>
          </Button>
        )
      }
    }
  ]

  const options = {
    columns,
    data,
    titleTableDoc: form.formLabel['gestcasos-editimpl-title-terimplicado']
  }

  return (
    <div>
      {Object.keys(data).length > 0 ? <DataTable {...options} /> : null}
    </div>
  )
}

const mapDispatchToProps = (dispatch) => ({
  onCleanState: () => dispatch(cleanStateCase())
})

export default connect(null, mapDispatchToProps)(TableImplicated)
